import{defaultProps,propTypes}from"./props";/**
 * The featured video component.
 * @returns {JSX}
 */var FeaturedVideo=function FeaturedVideo(){return null;};// Not yet implemented
FeaturedVideo.propTypes=propTypes;FeaturedVideo.defaultProps=defaultProps;FeaturedVideo.displayName='FeaturedVideo';export default FeaturedVideo;